<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch02">
<div class="chapterHead">
<h2 class="chapterTitle" style="text-indent: 0%;"><span class="bold">Dog and Me</span></h2></div>
<div class="chapterBody">
<p class="chapterOpenerText" style="text-indent: 0%;">An ant can look up at you, too, and even threaten you with its arms. Of course, my dog does not know I am human, he sees me as dog, though I do not leap up at a fence. I am a strong dog. But I do not leave my mouth hanging open when I walk along. Even on a hot day, I do not leave my tongue hanging out. But I bark at him: “No! No!”</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781466806276_ch02.vue?fbf8a5b0